function getStateAfterIncomeStatementUpdate(state, action) {
    return getStateFor(state, action.quarterNum, 'incomeStatement', action.updatedIncomeStatement);
}

function getStateAfterBalanceSheetUpdate(state, action) {
    return getStateFor(state, action.quarterNum, 'balanceSheet', action.updatedBalanceSheet);
}

function getStateAfterFinancialRatiosUpdate(state, action) {
    return getStateFor(state, action.quarterNum, 'financialRatios', action.updatedFinancialRatios);
}

function getStateFor(state, quarterNum, key, value) {
    return state.merge(
        {
            statementsByQuarterNum: {
                [quarterNum]: {
                    [key]: value,
                },
            },
        },
        { deep: true },
    );
}

export { getStateAfterIncomeStatementUpdate, getStateAfterBalanceSheetUpdate, getStateAfterFinancialRatiosUpdate };
